import Styles from './FJColorAndOpacitySet.module.less';
import opacityBase64 from '../../../assets/base64/opacity-base64.js';
import React, { useRef } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJToolTip from '../FJToolTip/FJToolTip';
import classNames from 'classnames';
import colorAndOpacityBase64 from '../../../assets/base64/color-and-opacity-base64.js';
import colorBase64 from '../../../assets/base64/color-base64.js';
import FJDropDown from '../FJDropDown/FJDropDown.jsx';
import FJColorPickerPanel from '../FJColorPickerPanel/FJColorPickerPanel.jsx';
import FJSliderSet from '../FJSliderSet/FJSliderSet.jsx';
import FJConstant from '../../../constants/FJConstant.js';

const FJColorAndOpacitySet = props => {
    const { color, hasOpacity = false, opacity = 100, onColorChange, onOpacityChange, isDisabled = false } = props;
    const dropDown = useRef(null);

    const _colorDataChange = (newColor, changeType = FJConstant.CHANGE_END) => {
        if (onColorChange) {
            onColorChange(newColor, changeType);
        }
    };

    const _opacityDataChange = (data, name = 'opacity', changeType = FJConstant.CHANGE_END) => {
        if (onOpacityChange) {
            onOpacityChange(Math.floor(data), changeType);
        }
    };

    if (isDisabled) {
        return (
            <div className={Styles.box}>
                <FJDropDown
                    hideEvent={'closeColorDropDown'}
                    isTopLayer={true}
                    ref={dropDown}
                    overlay={<div className={Styles.inner_disabled}>color_box</div>}
                />
            </div>
        );
    }

    const backStyle = color
        ? { background: color }
        : { backgroundImage: hasOpacity ? `url(${colorAndOpacityBase64})` : `url(${colorBase64})` };

    return (
        <div className={Styles.box}>
            <FJDropDown
                hideEvent={'closeColorDropDown'}
                isTopLayer={true}
                ref={dropDown}
                overlay={<FJColorPickerPanel activeColor={color} onChange={_colorDataChange} />}
            >
                <FJToolTip title={FJLocalStore._('color')}>
                    <div
                        className={classNames(Styles.inner, hasOpacity ? Styles.has_opacity : null)}
                        style={backStyle}
                    />
                </FJToolTip>
            </FJDropDown>
            {hasOpacity && (
                <FJDropDown
                    overlay={
                        <div className={Styles.opacity_panel}>
                            <FJSliderSet
                                min={0}
                                max={100}
                                value={opacity}
                                text={FJLocalStore._('opacity')}
                                onChange={_opacityDataChange}
                                mouseDownHideDropDown={false}
                            />
                        </div>
                    }
                    canTriggerActive
                    triggerDisplay='flex'
                    isTopLayer={true}
                    hideEvent={'closeColorDropDown'}
                >
                    <FJToolTip title={FJLocalStore._('transparent')}>
                        <img src={opacityBase64} className={Styles.opacity} alt='' />
                    </FJToolTip>
                </FJDropDown>
            )}
        </div>
    );
};

export default FJColorAndOpacitySet;
